import CheapBotWidget from '../components/CheapBotWidget';

// Cheap crashed-contract ignition bot (backend: handlers/cheap_bot.go).
// Strategy from the 2026-07-10 real-data study: a 0DTE contract crashed
// >=50% below its session high prints a local low, then jumps >=1.4x off it
// with a 3x volume spike while the underlying moves toward the strike.
// SPY trades real paper orders on Alpaca; SPX is watch-only with simulated
// fills (Alpaca cannot trade index options - verified live).
export default function CheapBot() {
  return (
    <div>
      <CheapBotWidget
        apiPath="/api/cheap-bot-spy"
        title="Cheap Bot (SPY) — Paper Trading"
        subtitle="Real Alpaca paper orders. 0DTE SPY, ±$15 strikes, entry cap $0.15/contract, 3 contracts, one trade at a time. Entry: marketable limit at ask on ignition (≥1.4x off a ≥50%-crashed local low + 3x volume spike + SPY moving toward strike). TP +100% resting limit, no SL, force-close 15:30 ET. PostPeak column shows what the fixed TP left on the table."
      />
      <CheapBotWidget
        apiPath="/api/cheap-bot-spx"
        title="Cheap Bot (SPX) — Watch Only"
        subtitle="Simulated fills (Alpaca cannot trade index options - verified: orders rejected for us_index asset class). Same ignition trigger at SPX scale: ±$100 strikes, entry cap $0.80/contract, entry at ask / exits at bid so spread cost stays honest. Builds the SPX evidence base for a future IBKR real-money port."
      />
    </div>
  );
}
